import React from 'react';
import FeaturedImage from '../FeaturedImage';

function programs(props) {
    const {
        post,
        postType,
    } = props;

    let categories;
    let categoryItems;
    let featuredImage;
    let categoriesElement;
    let maxDurationElement;
    let maxDurationValue;
    let durationLabel;
    let featuredImageCaptionElement = '';
    let featuredProgram;
    let priceElement;
    let minPriceValue;
    let maxPriceValue;
    let priceRange;
    let priceLabel;
    let monthlyPriceElement;
    let monthlyPriceValue;
    let monthlyPriceClasses;
    let cardClasses = 'program-card';

    function fullToMonthlyPrice( price = false ) {
        if ( ! price ) {
            return false;
        }

        let monthlyPrice;

        monthlyPrice = parseInt( price ) - 900;
        monthlyPrice = monthlyPrice * 1.34735105041;
        monthlyPrice = monthlyPrice / 24;

        return Math.round(monthlyPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    if (post.hasOwnProperty('featured_image') && post.featured_image) {
        featuredImage =
            <figure className='program-card__image'>
                <FeaturedImage
                    imageSize={'program-cards'}
                    image={post.featured_image}
                    srcset={post.featured_image}
                ></FeaturedImage>
            </figure>
    }

    if (post.hasOwnProperty('the_categories') && post.the_categories.length > 0) {
        categories = post.the_categories;
    }

    if (categories) {
        categoryItems = categories.map((category, index) => {

            if (category.taxonomy === 'programs_country') {
                return (
                    <span
                        key={index}
                    >{category.name}</span>
                );
            }

        });
        categoriesElement = <div className="program-card__content-taxonomy">
            <p>
                {categoryItems}
            </p>
        </div>
    }

    if (post.post_meta['featured_program'] && post.post_meta['featured_program'][0] && '1' === post.post_meta['featured_program'][0]) {
        cardClasses = cardClasses + ' featured';
        featuredProgram = <div className="program-card__featured"><p>Featured</p></div>
    }

    if (post.post_meta['custom_meta_max_duration']) {
        maxDurationValue = 1 === post.post_meta['custom_meta_max_duration'] ? post.post_meta['custom_meta_max_duration'] + ' week' : post.post_meta['custom_meta_max_duration'] + ' weeks';
        maxDurationElement = <div className="program-card__content-details-taxonomy-single program-card__content-details-taxonomy-single--duration">
            <h6>Duration</h6>
            <p dangerouslySetInnerHTML={{ __html: maxDurationValue }} />
        </div>
    }

    if (post.post_meta['custom_meta_min_duration'] && post.post_meta['custom_meta_max_duration']) {
        maxDurationValue = parseInt( post.post_meta['custom_meta_min_duration'] ) !== parseInt( post.post_meta['custom_meta_max_duration'] ) ? post.post_meta['custom_meta_min_duration'] + '-' + post.post_meta['custom_meta_max_duration'] : post.post_meta['custom_meta_max_duration'];
        maxDurationValue = 1 === post.post_meta['custom_meta_max_duration'] ? maxDurationValue + ' week' : maxDurationValue + ' weeks';
        durationLabel = parseInt( post.post_meta['custom_meta_min_duration'] ) !== parseInt( post.post_meta['custom_meta_max_duration'] ) ? 'Duration' : 'Duration';
        maxDurationElement = <div className="program-card__content-details-taxonomy-single program-card__content-details-taxonomy-single--duration">
            <h6>{durationLabel}</h6>
            <p dangerouslySetInnerHTML={{ __html: maxDurationValue }} />
        </div>
    }

    if (post.post_meta['custom_meta_price_max'] || post.post_meta['custom_meta_price_min']) {
        minPriceValue = post.post_meta['custom_meta_price_min'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        maxPriceValue = post.post_meta['custom_meta_price_max'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        priceRange = minPriceValue === maxPriceValue ? `$${minPriceValue}` : `$${minPriceValue} - $${maxPriceValue}`;
        priceLabel = minPriceValue === maxPriceValue ? `Price` : `Price`;
        priceElement = <div className="program-card__content-details-taxonomy-single program-card__content-details-taxonomy-single--price">

            <h6>{priceLabel}</h6>
            <p>
                <span className="program-card__content-details-taxonomy-single-price">{priceRange}</span>
            </p>
        </div>
    }

    if (post.post_meta['custom_meta_price_min']) {
        monthlyPriceValue = fullToMonthlyPrice( post.post_meta['custom_meta_price_min'] );
        monthlyPriceClasses = 'program-card__content-details-taxonomy-single-price-month';
        // monthlyPriceClasses = minPriceValue === maxPriceValue ? monthlyPriceClasses : monthlyPriceClasses + ' wide-label';
        monthlyPriceElement = <p className={monthlyPriceClasses}>
            {`from $${monthlyPriceValue}/month`}
        </p> 
    }

    let availability = 'open';
    let availabilityLabels = {
        open: 'Available',
        limited: 'Close to Full',
        closed: 'Full'
    };
    if (post.post_meta['custom_meta_availability']) {
        availability = post.post_meta['custom_meta_availability'];
    }

    return (
        <article id={`${postType}-${post.id}`} className={cardClasses} >
            <a className="program-card__link" href={post.link} aria-label="Post Link" target="_blank">
            <div className={'program-card__avilability program-card__avilability--' + availability }>
                <p>{ availabilityLabels[availability] }</p>
            </div>
            {featuredProgram}
            {featuredImage}
            <div className="program-card__content">
                {categoriesElement}
                <div className="program-card__content-details">
                    <h3 dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
                    <div className="program-card__content-details-taxonomy">
                        {maxDurationElement}
                        {priceElement}
                        {/* {monthlyPriceElement} */}
                    </div>
                </div>
            </div>
            <button className="program-card__button"><span>View Details</span></button>
            </a>
        </article>
    );
}

export default programs;